import React, { useCallback } from "react";
import styled from "styled-components";
import { Form, Row, Col } from "react-bootstrap";

import { hexToRGBA } from "../../../utils/theme";

import NonProfitOrgInfoBlock from "../input-blocks/NonProfitOrgInfoBlock";
import ResponsiblePartyInfoBlock from "../input-blocks/ResponsiblePartyInfoBlock";
import BusinessAddressBlock from "../input-blocks/BusinessAddressBlock";
import DatesBlock from "../input-blocks/DatesBlock";
import CommunicationBlock from "../input-blocks/CommunicationBlock";
import ActivityBlock from "../input-blocks/ActivityBlock";
import GeneralQuestionsBlock from "../input-blocks/GeneralQuestionsBlock";
import AgreementBlock from "../input-blocks/AgreementBlock";
import StyledButton from "../../styled/StyledButton";

const StyledEINNonProfitForm = styled(Form)`
  padding-top: 42px;
  padding-bottom: 62px;

  .inputs-block-title {
    margin-bottom: 32px;
    padding-left: 24px;
    padding-right: 24px;

    font-family: 'MerriweatherLight';
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    text-transform: capitalize;
    color: #1B3858;
    text-shadow: 1px 1px 0px #FFFFFF;

    span {
      span {
        color: #C61F0C;
      }
    }
  }

  .input-title {
    margin-bottom: 4px;
    font-family: 'LatoRegular';
    font-size: 14px;
    line-height: 24px;
    color: ${hexToRGBA('#1B3858', 0.7)};
    caret-color: ${hexToRGBA('#1B3858', 0.7)};
  }

  .inputs-block-divider {
    margin-bottom: 46px;
  }

  .disclaimer {
    font-family: 'LatoRegular';
    font-size: 10px;
    line-height: 22px;
    text-align: center;
    color: #1B3858;
    opacity: 0.7;
    text-shadow: 1px 1px 0px #FFFFFF;
  }

  button {
    width: 100%;
    margin-bottom: 1rem;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    padding-bottom: 42px;
  }
`;

function EINNonProfitForm({ values = {}, onChange, onSubmit }) {
  const handleSubmitButtonMouseDown = useCallback(() => {
    onChange && onChange({ target: { id: "suspendedSubmit", value: true } });
  }, [onChange]);

  return (
    <StyledEINNonProfitForm
      id="EINForm"
      noValidate
      validated={values.validated}
      onSubmit={onSubmit}
    >
      <NonProfitOrgInfoBlock
        values={values}
        onChange={onChange}
      />
      <ResponsiblePartyInfoBlock
        values={values}
        onChange={onChange}
      />
      <BusinessAddressBlock
        values={values}
        onChange={onChange}
      />
      <ActivityBlock
        values={values}
        onChange={onChange}
      />
      <GeneralQuestionsBlock
        values={values}
        onChange={onChange}
      />
      <Row>
        <Col xs={12} md={6}>
          <DatesBlock
            values={values}
            onChange={onChange}
          />
        </Col>
        <Col xs={12} md={6}>
          <CommunicationBlock
            values={values}
            onChange={onChange}
          />
        </Col>
      </Row>
      {/* <AgreementBlock /> */}
      <Row>
        <Col xs={0} md={3} />
        <Col xs={12} md={6}>
          <StyledButton type="submit" id="EINSubmitButton" onMouseDown={handleSubmitButtonMouseDown}>
            Submit Application
          </StyledButton>
        </Col>
        <Col xs={0} md={3} />
      </Row>
      <Row>
        <Col xs={12}>
          <div className="disclaimer">
            <span>Clicking on <strong>Submit</strong> Application means you agree to our Terms of Service and Privacy Policy.</span>
          </div>
        </Col>
      </Row>
    </StyledEINNonProfitForm>
  );
}

export default EINNonProfitForm;
